import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../utils/motion";
import Navbar from './Navbar';
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

const LOGIN_TITLES = ["Customer Login", "Staff Login"];

const LoginForm = ({ titleIndex = 0, accCreation = false, onLogin }) => {
  const title = LOGIN_TITLES[titleIndex] || "Login";

  return (
    <div className="w-full flex-1 pr-2">
      <div className="flex flex-col items-center gap-6">
        <motion.h3 variants={fadeIn("up", 0.4)} className="text-3xl md:text-5xl xl:text-6xl leading-snug tracking-wide text-center text-gray-800 truncate">
          {title}
        </motion.h3>

        <button
          className="w-full ml-auto bg-blue-600 text-white px-8 py-4 rounded-xl hover:bg-blue-700 cursor-pointer 
            transition-all hover:shadow-lg hover:shadow-blue-100 active:scale-95"
          onClick={onLogin}
        >
          →
        </button>
      </div>

      {accCreation && (
        <motion.p className="absolute ml-[12px] w-[300px] py-[50px] text-blue-500 font-semibold flex items-center gap-2 hover:gap-3 transition-all" variants={fadeIn("up", 0.2)}>
          
          Accounts can only be made by admin.
          
          </motion.p>
      )}
    </div>
  );
};

const customLinks = [
  { href: "/", label: "Home" },
  { href: "/#about", label: "About Us" },
  { href: "/#services", label: "Our Service" },
  { href: "/#newsletter", label: "Contact Us" },
];

const Home = () => {
  const navigate = useNavigate();
  const { instance, accounts, inProgress } = useMsal();

  const [userDisplayName, setUserDisplayName] = useState('NOT LOGGED IN');

  // Subscribe to MSAL events
  useEffect(() => {
    const checkAccount = () => {
      const activeAccount = instance.getActiveAccount();
      if (activeAccount) {
        setUserDisplayName(activeAccount.name || 'UNKNOWN USER');
      } else {
        setUserDisplayName('NOT LOGGED IN');
      }
        };

    // Check on mount
    checkAccount();
    

    // Listen for login/logout events
    const callbackId = instance.addEventCallback((event) => {
      if (event.eventType === "msal:loginSuccess" || event.eventType === "msal:logoutSuccess") {
        checkAccount();
      }
    });


    return () => {
      instance.removeEventCallback(callbackId);
    };
  }, [instance]);

  const handleLogin = async () => {
    try {

      const response = await instance.loginPopup({ scopes: ["User.Read"] });
      if (response?.account) {
        instance.setActiveAccount(response.account);
        navigate("/dashboard");
      }
    } catch (err) {
      console.error(err);
      alert("Login failed.");
    }
  };

  const handleCustomerLogin = async () => {
    try {
        navigate("/customer");
      
    } catch (err) {
      console.error(err);
      alert("Login failed.");
    }
  };


  return (
    <section id="login" className="flex flex-col container mx-auto h-screen">
      <Navbar links={customLinks} />
      <div id="wrapper" className="flex flex-col md:flex-row items-center md:justify-center gap-26 md:gap-6 lg:h-full lg:mt-0 mt-32 md:h-full max-w-screen-xl mx-auto w-full px-4 md:px-0">
        <LoginForm titleIndex={0} onLogin={handleCustomerLogin} />
        <LoginForm titleIndex={1} accCreation={true} onLogin={handleLogin} />

      </div>
    </section>
  );
};

export default Home;
